import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  infoTrack: {
    _id: "",
    title: "",
    track: "",
    artist: "",
    wikipedia: "",
    genre: "",
    release: "",
    cover: { big: "", small: "" },
    userRating: null,
    spotify: {
      url: "",
    },
    yandexMusic: {
      url: "",
    },
    appleMusic: {
      url: "",
    },
  },
};

export const radioSlice = createSlice({
  name: "trackInfo",
  initialState,
  reducers: {
    setInfoTrack: (state, action) => {
      state.infoTrack = {
        ...state.infoTrack,
        ...action.payload,
      };
    },
  },
});

export const { setInfoTrack } = radioSlice.actions;

export default radioSlice.reducer;
